import React, { ReactNode } from "react"
import * as styles from "./expertOpinion.module.scss"

interface IExpertOpinion {
  personName: string
  position: string
  avatarUrl: string
  text: ReactNode
  question: string
}

const hasMissingData = ({ personName, position, avatarUrl, text, question }: IExpertOpinion) =>
  !personName || !position || !avatarUrl || !text || !question

export function ExpertOpinion({ personName, position, avatarUrl, text, question }: IExpertOpinion) {
  if (hasMissingData({ personName, position, avatarUrl, text, question })) {
    return null
  }
  return (
    <div className={styles.expertOpinion}>
      <div className={styles.blockTitle}>{question}</div>
      <div className={styles.mainContent}>
        <div className={styles.person}>
          <img
            className={styles.avatar}
            src={avatarUrl}
            alt="Фотография профиля"
            loading="lazy"
            decoding="auto"
          />
          <div className={styles.info}>
            <div className={styles.personName}>{personName}</div>
            <div className={styles.position}>{position}</div>
          </div>
        </div>
        <div className={styles.text}>{text}</div>
      </div>
    </div>
  )
}
